export default __webpack_public_path__ + "static/media/download.929a2652.svg";